import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nefrologia-y-dialisis',
  templateUrl: './nefrologia-y-dialisis.component.html',
  styleUrls: ['./nefrologia-y-dialisis.component.css']
})
export class NefrologiaYDialisisComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
